




















import { Component, Vue } from "vue-property-decorator";
import GitLabSettings from "@/components/settings/GitLabSettings.vue";
import { readAccessToken } from "@/store/gitlab/getters";
import SetAccessToken from "@/components/settings/SetAccessToken.vue";
import About from "@/views/About.vue";
@Component({
  components: { About, SetAccessToken, GitLabSettings }
})
export default class Settings extends Vue {
  private accessTokenSet = readAccessToken(this.$store) !== "";
}
